import { t } from 'i18next';
import React from 'react';

import useSnackbar from '../../../hooks/useSnackbar';
import { getMetaContent } from '../../../lib/dom';
import { handle } from '../../../lib/logging';
import Uploader from '../Dropzone/Uploader';

type UploadFile = (newFile: File, handleUploadFinished: (signedId: string) => void) => void;

export type UseFileUpload = [uploadFile: UploadFile, progress: number | undefined];

const blogUploadIRI = getMetaContent('blob-upload');

export const useFileUpload = (): UseFileUpload => {
  const showSnackbar = useSnackbar();
  const directUploadUrl = blogUploadIRI;

  const [uploading, setUploading] = React.useState(false);
  const [progress, setProgress] = React.useState(0);

  const handleError = (error: Error) => {
    setUploading(false);
    showSnackbar(t('form.fileUploadFailed'));
    handle(error);
  };

  const handleProgress = (e: ProgressEvent) => {
    if (e.lengthComputable) {
      setProgress((e.loaded / e.total) * 100);
    }
  };

  const uploadFile = React.useCallback<UploadFile>((newFile, handleUploadFinished) => {
    setUploading(true);
    setProgress(0);

    const handleFinish = (signedId: string) => {
      setUploading(false);
      handleUploadFinished(signedId);
    };

    if (!directUploadUrl) {
      throw new Error('No upload url in manifest');
    }

    new Uploader(directUploadUrl, handleProgress, handleFinish, handleError).upload(newFile);
  }, []);

  return [uploadFile, uploading ? progress : undefined];
};
